import React from "react";

let includedOccurrenceFrequencies = [];
export class OccurrenceFrequencyLevel {
  public id: number;
  public label: string;
  public name: string;

  constructor(data: { id: number; label: string; name: string }) {
    this.id = data.id;
    this.label = data.label;
    this.name = data.name;
    this.save();
  }
  save() {
    includedOccurrenceFrequencies.push(this);
  }
  static includedOccurrenceFrequencies() {
    return includedOccurrenceFrequencies;
  }

  static findByName(name) {
    return includedOccurrenceFrequencies.find(
      (frequency) => frequency.name == name
    );
  }

  static findById(id) {
    return includedOccurrenceFrequencies.find(
      (frequency) => frequency.id == id
    );
  }
}
